import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	width: 100%;
	gap: 40px;
	align-items: center;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
`;

export const TableWrapper = styled.div`
	max-height: calc(100vh - 250px);
	overflow: scroll;
`;

export const ItemsWrapper = styled.div`
	display: flex;
	gap: 8px;
	flex-wrap: wrap;
	align-items: flex-end;
	max-width: 420px;
	margin-top: 10px;
	margin-bottom: 40px;
	margin-left: 160px;
`;

export const ItemsTitle = styled.p`
	font-weight: bold;
	font-size: 16px;
	color: ${Colors.darkBlue};
	margin: 12px 0 6px;
`;

export const Item = styled.div`
	cursor: pointer;
	background-color: ${Colors.green};
	padding: 5px 8px;
	color: white;
	text-align: center;
	border-radius: 10px;
	font-size: 14px;
`;

export const ListRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 12px;
`;

export const Title = styled.h3`
	color: ${Colors.darkBlue};
    margin-bottom: 20px;
`;